import INotification from './INotification';

export default interface INotificationResponse {
    notifications: INotification[];
    expirationDatetime: Date;
    expirationMinutes: number;
    showExpirationNotification: boolean;
}

export const blankNotification: INotificationResponse = {
    notifications: [],
    expirationDatetime: new Date(),
    expirationMinutes: 15,
    showExpirationNotification: false,
};
